module.exports = __webpack_public_path__ + "ttf/am-icon-font.6b9030.ttf";


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/core/client/assets/fonts/am-icon-font.ttf
 ** module id = 315
 ** module chunks = 12
 **/